export class DeleteDialog {
  open(factory: () => Promise<any>): Promise<boolean> {
    return Promise.resolve(false);
  }
}